import 'date-fns';
import React from 'react';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import TextField from '@material-ui/core/TextField';
const TextFieldComponent = props => {
  return <TextField {...props} disabled={true} />;
};

function CalendarDatePicker(props) {
  const {
    selectedDate,
    handleDateChange,
    disableFuture,
    readOnly,
    label,
    onKeyPress,
    autoOk,
    allowKeyboardControl,
  } = props;

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <KeyboardDatePicker
        disableToolbar
        disableFuture={disableFuture}
        autoOk={autoOk}
        variant="inline"
        format="MM/dd/yyyy"
        allowKeyboardControl={allowKeyboardControl}
        TextFieldComponent={TextFieldComponent}
        readOnly={readOnly}
        margin="normal"
        id="date-picker-inline"
        label={label}
        value={selectedDate}
        onChange={handleDateChange}
        onKeyPress={onKeyPress}
        KeyboardButtonProps={{
          'aria-label': 'change date',
        }}
      />
    </MuiPickersUtilsProvider>
  );
}

export default CalendarDatePicker;
